import { AnyEntity, AnyEntityId, EntityType } from "@mapmycustomers/shared/types/entity";

import EditActivityFocusableField from "../../component/activity/type/EditActivityFocusableField";
import RecordPaneTab from "../../enum/preview/RecordPaneTab";

export enum EntityViewSource {
  GLOBAL_SEARCH,
}

interface EntityViewPayload {
  edit?: boolean;
  editValues?: Partial<AnyEntity>; // currently is only used with Activity, but can be anything
  elementId?: string;
  entityId?: AnyEntityId;
  entityType?: EntityType;
  focusedFieldName?: EditActivityFocusableField;
  focusOnPin?: boolean;
  requiredFieldsOnly?: boolean;
  source?: EntityViewSource;
  tab?: RecordPaneTab;
  zIndex?: number; // if a custom z-index is needed
}

export default EntityViewPayload;
